import { handleSelectAll } from "./utilsTable";
import { useTranslation } from "react-i18next";

const ContainerHeader = ({
  data,
  setData,
  setContainersSelected,
  selectedAll,
  displayToBlock,
  noActivePackmat,
}) => {
  const { t } = useTranslation();

  return (
    <article
      className="table-header table-header-no-padding hidden lg:flex xl:flex 2xl:flex"
      style={{ borderBottom: "1.5px solid #e0e0e0", backgroundColor: "#fff" }}
    >
      {!displayToBlock && (
        <div className="data-table data-monitoring-checkbox">
          <input
            type="checkbox"
            className="w-4 h-4 cursor-pointer z-10"
            style={{ marginLeft: "8px", marginRight: "0px" }}
            onChange={(event) =>
              handleSelectAll(event, data, setData, setContainersSelected)
            }
            checked={selectedAll}
          />
        </div>
      )}
      <div className="data-table data-monitoring-releve">
        <span style={{ textAlign: "left", width: "100%" }}>{t("Relevé")}</span>
      </div>
      <div className="data-table data-monitoring-address">
        <span style={{ textAlign: "left", width: "100%" }}>{t("Address")}</span>
      </div>
      <div className="data-table data-monitoring-status">
        <span style={{ textAlign: "right", width: "100%" }}>{t("Status")}</span>
      </div>
      <div className="data-table data-monitoring-sorting-errors">
        <span style={{ textAlign: "right", width: "100%" }}>
          {t("sorting_errors")}
        </span>
      </div>
      {!noActivePackmat && (
        <div className="data-table data-monitoring-packmat">
          <span style={{ textAlign: "right", width: "100%" }}>
            {t("Packmat")}
          </span>
        </div>
      )}
      <div
        className="data-table data-monitoring-action-recommended"
        style={{
          overflow: "hidden",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <span
          style={{
            textAlign: "right",
            width: "100%",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {t("Conseil")}
        </span>
      </div>
      <div className="data-table data-monitoring-weight">
        <span style={{ textAlign: "right", width: "100%" }}>{t("Weight")}</span>
      </div>
      <div className="data-table data-monitoring-filling">
        <span style={{ textAlign: "right", width: "100%" }}>
          {t("Remplissage")}
        </span>
      </div>
      <div className="data-table data-monitoring-actions"></div>
    </article>
  );
};

export default ContainerHeader;
